module.exports = __webpack_public_path__ + "img/los-cabos_ballenas.4db05448.jpg";